// Centralised Sortable instance with the MultiDrag plugin mounted once.
import Sortable, { MultiDrag } from 'sortablejs';

// guard against double-mounting across HMR reloads
if (!(Sortable as unknown as { __multiDragMounted?: boolean }).__multiDragMounted) {
  Sortable.mount(new MultiDrag());
  (Sortable as unknown as { __multiDragMounted?: boolean }).__multiDragMounted = true;
}

export default Sortable;
